import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_LANG } from "shared/constants/common.constants";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type LangState = {
  lang: string;
};

const initialLangState: LangState = {
  lang: DEFAULT_LANG,
};

const langSlice = createSlice({
  name: "lang",
  initialState: initialLangState,
  reducers: {
    setLang: (state, action: PayloadAction<string>) => {
      state.lang = action.payload;
    },
  },
});

const langBaseSelector = createBaseSelector(langSlice);

registerSlice([langSlice]);

export const langStore = {
  actions: langSlice.actions,
  selectors: {
    lang: createSelector(langBaseSelector, (s) => s.lang),
  },
};
